<template>
  <div class="home">
    <b-container>
      <ClientForm/>
    </b-container>
  </div>
</template>

<script>
import ClientForm from '@/components/ClientForm.vue';
export default {
  name: 'newclient',
  components: {
    ClientForm
  }
}
</script>